import { useMutation } from "@apollo/client";
import { Button, Grid, Paper, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/system";
import { Form, Input } from "antd";
import { useState } from "react";
import Message from "../../Components/Message";
import { REQUEST_RESET_PASSWORD } from "../../Graphql/Mutations";
import { Error } from "../../Types/MessageType";

const ForgetPassword = () => {
  const theme = useTheme();
  const [form] = Form.useForm();
  const [alert, setAlert] = useState<Error>();
  const [requestResetPassword] = useMutation(REQUEST_RESET_PASSWORD);

  const resetPasswordHandler = async (values: { email: string }) => {
    try {
      const { data } = await requestResetPassword({
        variables: { email: values.email },
      });

      if (data.requestResetPassword.success) {
        setAlert({
          type: 'success',
          message: data.requestResetPassword.message,
        });
      } else {
        setAlert({
          type: 'error',
          message: data.requestResetPassword.message,
        });
      }
    } catch (error: any) {
      setAlert({
        type: 'error',
        message: error.message,
      });
    }
  };

  return (
    <Grid container height={"100%"} sx={{ minHeight: '700px' }} width={'100vw'} justifyContent="center" alignItems="center" px={{ sm: 2, md: 20 }}>
      <Grid item md={6}>
        <Paper elevation={2} sx={{ backgroundColor: theme.palette.background.paper, pt: 8, pb: 8, px: 4, marginTop: '35px' }}>
          <Typography color={'primary'} textAlign={'center'} variant={'h5'} sx={{ mb: 3 }}>
            Forgot Password
          </Typography>
          <Typography textAlign={'center'} variant={'body1'} sx={{ mb: 4 }}>
            Please provide your email address and we'll send you a link to reset your password.
          </Typography>
          <Form
            form={form}
            layout={'vertical'}
            style={{ padding: '0 10%' }}
            onFinish={resetPasswordHandler}
          >
            <Form.Item
              label="Email ID"
              name="email"
              rules={[{ required: true, message: 'Please input your email address' }, { type: 'email', message: 'Please enter a valid email address' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item style={{ marginTop: '10px', marginBottom: '-30px' }}>
              <Button type={'submit'} variant={'contained'} style={{ margin: '0 40%', color: 'white', height: '45px' }}>
                Submit
              </Button>
            </Form.Item>
          </Form>
          <Box height={theme.status.errorMessageSpace}>
            {!!alert?.message ? <Message type={alert?.type} message={alert.message} /> : null}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ForgetPassword;